'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _templateComponentTypes = require('constants/templateComponentTypes');

var componentTypes = _interopRequireWildcard(_templateComponentTypes);

var _templateModeTypes = require('constants/templateModeTypes');

var modeTypes = _interopRequireWildcard(_templateModeTypes);

var _wrapTemplateComponent = require('helpers/wrapTemplateComponent');

var _wrapTemplateComponent2 = _interopRequireDefault(_wrapTemplateComponent);

var _templates = require('redux/modules/templates');

var _components = require('components');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  var _componentTypes$AIR$c, _componentTypes$AIR$c2;

  var component = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var mode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : modeTypes.EDITOR;

  var type = (_componentTypes$AIR$c = {}, (0, _defineProperty3.default)(_componentTypes$AIR$c, componentTypes.AIR, 'Air'), (0, _defineProperty3.default)(_componentTypes$AIR$c, componentTypes.CAR, 'Car'), (0, _defineProperty3.default)(_componentTypes$AIR$c, componentTypes.HOTEL, 'Hotel'), (0, _defineProperty3.default)(_componentTypes$AIR$c, componentTypes.CONTAINER, 'Container'), (0, _defineProperty3.default)(_componentTypes$AIR$c, componentTypes.CONTAINER_NO_PROPS, 'ContainerNoProps'), (0, _defineProperty3.default)(_componentTypes$AIR$c, componentTypes.INPUT_TEXT, 'InputText'), (0, _defineProperty3.default)(_componentTypes$AIR$c, componentTypes.TEXTAREA, 'Textarea'), (0, _defineProperty3.default)(_componentTypes$AIR$c, componentTypes.LABEL, 'Label'), (0, _defineProperty3.default)(_componentTypes$AIR$c, componentTypes.TABS, 'Tabs'), _componentTypes$AIR$c)[component && component.type];

  var actions = (_componentTypes$AIR$c2 = {}, (0, _defineProperty3.default)(_componentTypes$AIR$c2, componentTypes.AIR, { selectComponent: _templates.selectComponent, changeProperty: _templates.changeComponentProperty }), (0, _defineProperty3.default)(_componentTypes$AIR$c2, componentTypes.CAR, { selectComponent: _templates.selectComponent, changeProperty: _templates.changeComponentProperty }), (0, _defineProperty3.default)(_componentTypes$AIR$c2, componentTypes.HOTEL, { selectComponent: _templates.selectComponent, changeProperty: _templates.changeComponentProperty }), (0, _defineProperty3.default)(_componentTypes$AIR$c2, componentTypes.CONTAINER, { selectComponent: _templates.selectComponent, changeProperty: _templates.changeComponentProperty }), (0, _defineProperty3.default)(_componentTypes$AIR$c2, componentTypes.CONTAINER_NO_PROPS, {}), (0, _defineProperty3.default)(_componentTypes$AIR$c2, componentTypes.INPUT_TEXT, { selectComponent: _templates.selectComponent, changeProperty: _templates.changeComponentProperty }), (0, _defineProperty3.default)(_componentTypes$AIR$c2, componentTypes.TEXTAREA, { selectComponent: _templates.selectComponent, changeProperty: _templates.changeComponentProperty }), (0, _defineProperty3.default)(_componentTypes$AIR$c2, componentTypes.LABEL, { selectComponent: _templates.selectComponent, changeProperty: _templates.changeComponentProperty }), (0, _defineProperty3.default)(_componentTypes$AIR$c2, componentTypes.TABS, { setTab: _templates.setTab }), _componentTypes$AIR$c2)[component && component.type] || {};

  var Component = _components.TemplateComponents[type] && _components.TemplateComponents[type][mode];

  return Component ? (0, _wrapTemplateComponent2.default)(Component, component, actions) : null;
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/helpers/createTemplateComponent/createTemplateComponent.jsx
// module id = 50
// module chunks = 0